// TeamSelect.jsx
import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem, Box, Typography } from '@mui/material';
import unifiedApi from '../utils/unifiedApi';

export default function TeamSelect({ value, onChange, label = "Select a team", variant = "outlined", size = "medium" }) {
  const [teams, setTeams] = useState([]);

  const isWhiteColor = (color) => {
    if (!color) return false;
    const normalizedColor = color.toLowerCase().trim();
    // Check for common white color representations
    return normalizedColor === '#ffffff' || 
           normalizedColor === '#fff' || 
           normalizedColor === 'white' || 
           normalizedColor === 'rgb(255,255,255)' ||
           normalizedColor === 'rgb(255, 255, 255)';
  };

  const getDisplayColor = (jerseyColorHex) => {
    if (!jerseyColorHex) return 'inherit';
    return isWhiteColor(jerseyColorHex) ? '#666666' : jerseyColorHex;
  };

  useEffect(() => {
    unifiedApi.getTeams()
      .then(data => setTeams(data || []))
      .catch(err => console.error('Failed to load teams:', err));
  }, []);

  return (
    <FormControl variant={variant} size={size} fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select 
        value={value || ''} 
        onChange={e => onChange(Number(e.target.value) || null)}
        label={label}
        renderValue={(selectedValue) => {
          if (!selectedValue) return '';
          const selectedTeam = teams.find(team => team.id === selectedValue);
          if (!selectedTeam) return selectedValue;
          
          return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {selectedTeam.logoUrl && (
                <img 
                  src={selectedTeam.logoUrl} 
                  alt={`${selectedTeam.name} logo`}
                  style={{
                    width: '20px',
                    height: '20px',
                    objectFit: 'contain',
                    borderRadius: '2px'
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              )}
              {selectedTeam.jerseyColorHex && (
                <Box
                  sx={{
                    width: 12,
                    height: 12,
                    backgroundColor: getDisplayColor(selectedTeam.jerseyColorHex),
                    borderRadius: '50%',
                    border: '1px solid rgba(0,0,0,0.2)',
                    flexShrink: 0
                  }}
                />
              )}
              <Typography sx={{ color: getDisplayColor(selectedTeam.jerseyColorHex) }}>
                {selectedTeam.name}
              </Typography>
            </Box>
          );
        }}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {teams.map(team => (
          <MenuItem key={team.id} value={team.id}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
              {team.logoUrl && (
                <img 
                  src={team.logoUrl} 
                  alt={`${team.name} logo`}
                  style={{
                    width: '20px',
                    height: '20px',
                    objectFit: 'contain',
                    borderRadius: '2px'
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              )}
              {team.jerseyColorHex && (
                <Box
                  sx={{
                    width: 12,
                    height: 12,
                    backgroundColor: getDisplayColor(team.jerseyColorHex),
                    borderRadius: '50%',
                    border: '1px solid rgba(0,0,0,0.2)',
                    flexShrink: 0
                  }}
                />
              )}
              <Typography sx={{ color: getDisplayColor(team.jerseyColorHex) }}>
                {team.name} (ID: {team.id})
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}